import { render, staticRenderFns } from "./TemplateForm.vue?vue&type=template&id=66200fa0&scoped=true"
import script from "./TemplateForm.vue?vue&type=script&lang=js"
export * from "./TemplateForm.vue?vue&type=script&lang=js"
import style0 from "./TemplateForm.vue?vue&type=style&index=0&id=66200fa0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66200fa0",
  null
  
)

export default component.exports